// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"fe595d79b5847fe6","1643":"61bdba8744c26852"}[chunkId] + ".js";
};